// extracted by mini-css-extract-plugin
module.exports = {"pillSection":"_9x9BXKWA"};